import React, { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Colors } from 'core/CssVariables';
import { SPageSpinnerWrapper, SSpinner } from './Spinner.style';
import { TSpinnerProps } from './Spinner.type';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const PageSpinner: FC<TSpinnerProps> = ({
  size,
  color,
  width,
  className = '',
}) => {
  return (
    <SPageSpinnerWrapper align="middle" justify="center">
      <SSpinner
        width={width}
        className={className}
        size={size || 'large'}
        indicator={antIcon}
        style={{ color: color || Colors.PrimaryColor }}
      />
    </SPageSpinnerWrapper>
  );
};

export const Spinner: FC<TSpinnerProps> = ({
  size,
  color,
  width,
  className = '',
  centered,
}) => {
  return (
    <SSpinner
      width={width}
      className={`${className} ${centered ? 'centered' : ''}`}
      size={size || 'small'}
      indicator={antIcon}
      style={{ color: color || Colors.PrimaryColor }}
    />
  );
};
